import useCurrentUser from "./useCurrentUser";

const useCurrentUserPermissions = () => {
    const userSummary = useCurrentUser();
    return userSummary?.permissions || [];
};

export default useCurrentUserPermissions;
